import { gql } from 'apollo-angular'

export const VALIDATE_ORGANIZATION_DOMAINS = gql`
  query validateOrganizationDomains($domains: [String!]!) {
    validateOrganizationDomains(organizationDomains: $domains) {
      areValid
    }
  }
`
